export const actionTypes = {
  SET_IMAGE_HREF: "IMAGE_VIEWER/SET_IMAGE_HREF",
  CLEAR_IMAGE_HREF: "IMAGE_VIEWER/CLEAR_IMAGE_HREF"
};
